export enum PatientCalendarEvents {
  groupsTabRegisterForGroupButtonClicked = 'Groups Tab Register For Group Button Clicked',
  registerUserForGroupConfirmationModalRegisterUserClicked = 'Register User For Group Confirmation Modal Register User Clicked',
  registerUserForGroupModalListCardClicked = 'Register User For Group Modal List Card Clicked',
  dailyViewTabButtonClicked = 'Daily View Tab Button Clicked',
  weeklyViewTabButtonClicked = 'Weekly View Tab Button Clicked',
  groupsTabButtonClicked = 'Groups Tab Button Clicked',
  groupsTabViewed = 'Groups Tab Viewed',
  groupsListKebabMenuUnRegisterButtonClicked = 'Groups List Kebab Menu Unregister Button Clicked',
  groupsListDetailModalKebabMenuUnRegisterButtonClicked = 'Groups Detail Modal Kebab Menu Unregister Button Clicked',
  groupsListKebabMenuViewButtonClicked = 'Groups List Kebab Menu View Button Clicked',
  groupsListKebabMenuChooseDifferentSectionButtonClicked = 'Groups List Kebab Menu Choose Different Section Button Clicked',
  groupsListCardButtonClicked = 'Groups List Card Button Clicked',
  unRegisterConformationModalUnRegisterUserButtonClicked = 'Unregister Conformation Modal Unregister User Button Clicked',
}
